'use client'
import { Flex, Image, Stack, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import WalletIcon from '@/app/[locale]/price/stocks/[symbol]/_components/Icon/Wallet'
import { getCurrencyFlagUrl } from '@/i18n/country'
import clsx from '@/utils/clsx'

import styles from './index.module.css'

type PaymentMethod = 'usd' | 'wallet'

export default function PayWith() {
  const t = useTranslations('tradeWidget')
  // const { countryCode } = useSsrContext()
  const [selectedMethod, setSelectedMethod] = useState<PaymentMethod>('usd')
  const currency = 'USD'

  const paymentMethods = [
    {
      id: 'usd' as PaymentMethod,
      icon: <Image src={getCurrencyFlagUrl(currency)} w={24} h={24} alt={t('currencyFlagAlt')} />,
      title: t('availableCurrency', { currency }),
      subtitle: t('instantNoFees'),
    },
    {
      id: 'wallet' as PaymentMethod,
      icon: <WalletIcon />,
      title: t('cryptoComWallet'),
      subtitle: t('instant'),
    },
  ]

  return (
    <Stack gap={12}>
      <Text variant={'body-emphasis'}>{t('payWith')}</Text>
      <Stack gap={0} className={styles.payWith}>
        {paymentMethods.map(method => (
          <Flex
            key={method.id}
            className={clsx({
              [styles.payWithItem]: true,
              [styles.payWithItemClickable]: true,
            })}
            onClick={() => setSelectedMethod(method.id)}
          >
            {method.icon}
            <Stack ml={8} gap={0} flex={1}>
              <Text variant={'body'}>{method.title}</Text>
              <Text variant={'subtitle'} c={'var(--content-secondary)'}>
                {method.subtitle}
              </Text>
            </Stack>
            <div
              className={
                selectedMethod === method.id
                  ? styles.payWithItemCheckBoxActive
                  : styles.payWithItemCheckBox
              }
            />
          </Flex>
        ))}
      </Stack>
    </Stack>
  )
}
